import React, {Fragment} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";
import AsyncSelect from "react-select/async";


const SizeMatrixForm = (props) => {
    const {errors, control, register, setValue, trigger, getValues, setOptions, sizeMatrix} = props;

    return (
        <Fragment>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Name</Label>
                        <input name="name" type="text" {...register('name')}
                               className={`form-control ${errors.name ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.name?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Size Matrix</Label>
                        <AsyncSelect
                            isMulti
                            isClearable
                            cacheOptions
                            defaultOptions
                            defaultValue={getValues('composition_group')}
                            loadOptions={sizeMatrix}
                            onChange={(e) => {
                                setValue('composition_group', e)
                            }}

                        />
                        <div className="invalid-feedback">{errors.composition_group?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    )
}

export default SizeMatrixForm;